import React, {useState} from 'react'
import WhiteRight from '../../../../media/felsv/white_right-arrow_icon.svg'
import {useHistory} from 'react-router'
import {ProductosF} from '../../../../interfaces/facturacion.interface'
import {State} from '../../../../reducers'
import {useDispatch, useSelector} from 'react-redux'
import {facturacionModalsOpenQuitarTodo} from '../../../../actions/facturacion/facturacionProductos.actions'
import {generalOpenModalError, generalOpenModalInfo} from '../../../../actions/general.actions'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision} from '../../../../actions/action-creators'
import {isNullOrEmpty} from '../../../../utils/strings.utils'
import ModalConfirm from '../../../../components/Modals/Generales/ModalConfirm'

const mensajeError = 'No existen productos para eliminar'

const Footer = () => {
  const history = useHistory()
  const arrayProductos: Array<ProductosF> = useSelector(
    (state: State) => state.facturacion.arrayProductos
  )
  const {pagoCompletado} = useSelector((state: State) => state.formaPago)
  const [modalConfirm, setModalConfirm] = useState(false)
  const formCliente = useSelector((state: State) => state.facturacion.formCliente)
  const activeDoc = useSelector((state: State) => state.documentos.activeDoc)

  const dispatch = useDispatch()
  const {facturacionClicGenerarFactura, facturacionGetUUID} = bindActionCreators(actionFacturacionEmision, dispatch)

  const generarFactura = async () => {
    if (await facturacionClicGenerarFactura()) {
      if(!pagoCompletado){
        dispatch(generalOpenModalInfo('El monto total de pago debe ser igual al total a pagar'))
        return
      }

      if (isNullOrEmpty(formCliente.tipoDocumento) && (activeDoc.idDoc && activeDoc.idDoc === '01')) {
        setModalConfirm(true)
        return
      }
      facturacionGetUUID("01")
      history.push('/emitir-factura/resumen')
    }
  }

  const openModalQuitarTodo = () => {
    if (arrayProductos.length === 0) return dispatch(generalOpenModalError(mensajeError))
    dispatch(facturacionModalsOpenQuitarTodo())
  }

  const avanzar = () => {
    facturacionGetUUID("01")
    setModalConfirm(false)
    history.push('/emitir-factura/resumen')
  }

  const cancelar = () => {
    setModalConfirm(false)
    window.scroll(0, 0)
  }

  return (
    <>
      {modalConfirm && (
        <ModalConfirm Styles={{maxWidth: "500px"}}
          title={'Confirmar Emisión de Factura Consumidor Final'}
          detail={
            'Estás a punto de generar una factura como Consumidor Final, ¿Estás seguro que deseas continuar?'
          }
          messageAction='Sí'
          messageClose='No'
          actionConfirm={avanzar}
          closeModalConfirm={cancelar}
        />
      )}
      <div className='w-layout-hflex button-actions'>
        <button className='m button transparent botton-footer' onClick={openModalQuitarTodo}>
          <div>Quitar todo</div>
        </button>
        <div style={{width: '65%'}}></div>
        <button className='m button botton-footer' onClick={generarFactura}>
          <div>Generar factura</div>
          <img src={WhiteRight} loading='lazy' alt='Generar' />
        </button>
      </div>
    </>
  )
}

export default Footer
